// Libs
import React from 'react';

import { Route, Routes, useLocation, Outlet } from 'react-router-dom';

import { Config, deepFinder } from '@ibinder/common-utils';

// Data
import { getTabs } from './placeholderData';
import AdminLandingPage from './AdminLandingPage';
import PrivateRoute from '../../routes/PrivateRoute';
import AdminContentContainer from './AdminContentContainer';
import AdminLayout from './AdminLayout';
import { EXTRACT_TAB_ID } from '../../utils/extractTabId';

// Feature toggle
import { useFeatureToggle } from '@ibinder/ui-common-hooks';

const AdminLayoutWrapper = ({ activeTabId, location }) => {
  return (
    <AdminLayout activeTabId={activeTabId} location={location}>
      <Outlet />
    </AdminLayout>
  );
};

const BinderWrapper = () => {
  const { isEnabled: showBatchOperations } = useFeatureToggle(
    // @ts-ignore -- TODO add to feat const /Jonathan 2026-01-12
    'batchOperations',
    Config.OPERATIONAL_CONFIG
  );

  const theTabs = getTabs(showBatchOperations);

  const location = useLocation();
  const activeTabId =
    location.pathname && EXTRACT_TAB_ID(location.pathname)
      ? EXTRACT_TAB_ID(location.pathname).slice(1)
      : '';
  let CURRENT_NODE_DATA = deepFinder(theTabs, activeTabId, 'subTabs');

  return (
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route
          element={
            <AdminLayoutWrapper activeTabId={activeTabId} location={location} />
          }
        >
          <Route path="/" element={<AdminLandingPage />} />
          <Route
            path={'/tab/:tabId/GlobalBinderTemplateList/:templateId'}
            element={
              <AdminContentContainer
                nodeData={CURRENT_NODE_DATA}
                tabs={theTabs}
              />
            }
          />
          <Route
            path={'/tab/:tabId/provider/*'}
            element={
              <AdminContentContainer
                nodeData={CURRENT_NODE_DATA}
                tabs={theTabs}
              />
            }
          />
          <Route
            path={'/tab/*'}
            element={
              <AdminContentContainer
                nodeData={CURRENT_NODE_DATA}
                tabs={theTabs}
              />
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default BinderWrapper;
